module.exports = __webpack_public_path__ + "img/mail-reply.a9abbe86.svg";